var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"editor",staticClass:"editor",staticStyle:{"background":"#000000"},attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }